<template>
  <div class="app-main-content">
    <quotation-list ref="qutFcl" :quotation-type="PriceConstant.QUOTATION_FCL" />
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import QuotationList from '@/views/cargo/v0/Price/Quotation/components/quotationList'
export default {
  name: 'QuotationFcl',
  components: { QuotationList },
  data() {
    return {
      PriceConstant,
      activeTabName: 'qutFcl'
    }
  }
}
</script>

<style scoped>

</style>
